<template>
	<v-card>
		<v-card-title style="display: block;">
			<div class="d-flex">
				<span class="headline">مدیریت ضامن ها</span>
				<v-spacer />
				<v-btn @click="$emit('close')" icon>
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</div>
		</v-card-title>
		<v-card-text>
			<v-container>
				<div>
					<div v-if="loading">
						<div class="success--text text-h4 text-center">
							در حال دریافت اطلاعات...
						</div>
					</div>
					<div v-else>
						<div v-if="!items.length">
							<h3 class="text-center red--text">تاکنون عنوانی در سیستم ثبت نشده است</h3>
							<div class="text-center mt-5">
								<v-btn class="mx-auto" color="secondary" dark @click="add" small>
									<v-icon dark>
										mdi-plus-circle-outline
									</v-icon>
									افزودن عنوان
								</v-btn>
							</div>
						</div>
						<div v-else>
							<v-card v-for="(assuranceRequirement, index) in items" :key="assuranceRequirement.id + index" class="mb-3 pa-3" elevation="0" color="#eee">
								<v-card-text>
									<v-form :ref="`form`" lazy-validation>
										<div class="">
											<v-text-field v-model="assuranceRequirement.title" label="عنوان موضوع" :error-messages="errorMessages" :rules="[(val) => !!val || 'عنوان موضوع را وارد کنید']" required />
										</div>
										<v-card color="#fff" flat class="mt-3 py-2">
											<table>
												<thead>
													<tr>
														<th class="text-h6 pa-3" style="width: 60%;border-bottom: 1px solid #dca6e5">شرح آیتم</th>
														<th class="text-h6 pa-3" style="width: 30%;border-bottom: 1px solid #dca6e5">اولویت نمایش</th>
														<th class="text-h6 pa-3" style="width: 10%;border-bottom: 1px solid #dca6e5">عملیات</th>
													</tr>
												</thead>
												<tbody>
													<tr v-if="!assuranceRequirement.assuranceRequirementItems || !assuranceRequirement.assuranceRequirementItems.length">
														<td class="text-center" colspan="3">آیتمی تعریف نشده است</td>
													</tr>
													<tr v-for="(assuranceRequirementItem, index2) in assuranceRequirement.assuranceRequirementItems" :key="assuranceRequirementItem.id + index2">
														<td cols="12" sm="6" class="px-1">
															<v-text-field v-model="assuranceRequirementItem.title" label="" :error-messages="errorMessages" :rules="[(val) => !!val || 'عنوان را وارد کنید']" required />
														</td>
														<td cols="12" sm="4" class="px-1">
															<v-text-field v-model="assuranceRequirementItem.order" label="" type="number" :error-messages="errorMessages" />
														</td>
														<td cols="12" sm="2">
															<v-btn @click="removeItem(assuranceRequirement, assuranceRequirementItem, index2)" class="ms-2" x-small icon color="pink" title="حذف">
																<v-icon>
																	mdi-close
																</v-icon>
															</v-btn>
														</td>
													</tr>
												</tbody>
											</table>
											<div class="text-center mt-2">
												<v-btn class="mx-auto" color="secondary" dark @click="addItem(assuranceRequirement)" small>
													<v-icon dark>
														mdi-plus-outline
													</v-icon>
												</v-btn>
											</div>
										</v-card>
									</v-form>
								</v-card-text>
								<v-card-actions>
									<v-spacer />
									<v-btn :loading="removeLoading === assuranceRequirement.id" small color="pink" dark @click="remove(assuranceRequirement, index)" title="حذف" fab>
										<v-icon>mdi-trash-can-outline</v-icon>
									</v-btn>
									<v-btn :loading="submitLoading == `${assuranceRequirement.id}${index}`" @click="save(assuranceRequirement, index)" color="success" small fab>
										<v-icon dark>
											mdi-content-save-outline
										</v-icon>
									</v-btn>
								</v-card-actions>
							</v-card>
							<div class="text-center mt-2">
								<v-btn class="mx-auto" color="secondary" dark @click="add">
									<v-icon dark>
										mdi-plus-circle-outline
									</v-icon>
									تعریف ضامن جدید
								</v-btn>
							</div>
						</div>
					</div>

				</div>
			</v-container>
		</v-card-text>
		<confirm-dlg ref="confirm" />
	</v-card>

</template>

<script>
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'
	import { cloneDeep } from 'lodash'
	import { call, get } from 'vuex-pathify'

	export default {
		name: 'AssuranceRequirements',
		props: {
			data: { type: Object },
			loan: { type: Object },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {
				emptyId: emptyId,
				errorMessages: '',
				items: [],
				submitLoading: '',
				removeLoading: '',
				loading: false,
			}
		},
		computed: {

		},
		mounted() {
			this.loadData()
		},
		methods: {
			fetchAssuranceRequirements: call('assuranceRequirements/fetch'),
			loadData(force = false) {
				this.loading = true
				this.fetchAssuranceRequirements({ force: force }).then(items => {
					this.items = cloneDeep(items)
				}).catch(err => { toast.error(err.message) })
					.finally(x => { this.loading = false })
			},
			save(item, index) {
				if (!this.$refs.form[index].validate()) {
					toast.error('لطفا موارد خواسته شده را تکمیل نمایید')
					return
				}
				this.submitLoading = `${item.id}${index}`
				var clone = { ...item }
				api.post('admin/AssuranceRequirement/' + (item.id === emptyId ? 'create' : 'edit'), clone)
					.then(response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						this.loadData(true)
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.submitLoading = false })
			},
			async remove(item, index) {
				if (!item) {
					return
				}

				if (item.id == emptyId) {
					this.items.splice(index, 1)
					return
				}

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					this.removeLoading = item.id
					api.post('admin/AssuranceRequirement/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.loadData(true)
							})
						.catch(err => {
							toast.error(err.message)
						})
						.finally(x => {
							this.removeLoading = ''
						})
				}
			},
			add() {
				let newItem = {
					id: emptyId,
					title: '',
					order: 0,
					assuranceRequirementItems: []
				}
				this.items.push(newItem)
			},
			addItem(item) {
				if (!item.assuranceRequirementItems) {
					item.assuranceRequirementItems = []
				}
				let newItem = {
					id: emptyId,
					title: '',
					order: 0,
				}
				item.assuranceRequirementItems.push(newItem)
			},
			removeItem(parent, item, index) {
				if (!item) {
					return
				}
				parent.assuranceRequirementItems.splice(index, 1)
			},
		},
	}
</script>
<style></style>
